/**
 * Share-link parsing shared by the clipboard detector and the URL handler.
 */

const SHARE_HOSTS = ['susucloset.com', 'www.susucloset.com', 'localhost', '127.0.0.1'];

// Tokens are 16 random bytes rendered as hex
const TOKEN_PATTERN = /^[a-f0-9]{24,64}$/i;

/**
 * Pull a share token out of arbitrary text (a pasted link, a clipboard read).
 *
 * Deliberately strict about the host so an unrelated URL carrying a `share`
 * query param never triggers a claim prompt.
 *
 * @param {string} text
 * @returns {string|null} the token, or null when the text isn't a share link
 */
export const extractShareToken = (text) => {
  if (!text || typeof text !== 'string') return null;

  const trimmed = text.trim();
  if (trimmed.length > 2000) return null;

  const urlMatch = trimmed.match(/https?:\/\/[^\s]+/i);
  if (!urlMatch) return null;

  let url;
  try {
    url = new URL(urlMatch[0]);
  } catch {
    return null;
  }

  if (!SHARE_HOSTS.includes(url.hostname)) return null;

  const token = url.searchParams.get('share');
  if (!token || !TOKEN_PATTERN.test(token)) return null;

  return token;
};

export default extractShareToken;
